import type { ComponentProps } from 'react';
import type { WrapperFC } from '@george-labs.com/design-system';
import { TableCell } from '@george-labs.com/design-system';

interface Props extends ComponentProps<typeof TableCell> {
    columnId: string;
}

export const ResponsiveTableCell: WrapperFC<Props> = ({
    columnId,
    ...tableCellProps
    // eslint-disable-next-line react/jsx-props-no-spreading
}) => <TableCell {...tableCellProps} />;

ResponsiveTableCell.wrapsComponent = TableCell;
